import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Site} from './common/services';
import {environment} from '@Env/environment';

@Injectable({
  providedIn: 'root'
})
export class BdcService {
  private url = `${environment.baseUrl}/api_bdc/sites/`;
  private url_pages = `${environment.baseUrl}/api_bdc/pages/`;
  constructor(private http: HttpClient) { }

  /**
   * Find all
   * @param offset Offset
   * @param limit Limit
   */
  findAll(offset?: number, limit?: number) {
    return this.http.get<Site[]>(this.url);
  }
  /**
   * Find
   * @param id Id
   */
  find(id: string) {
    const url = `${this.url}${id}`;
    return this.http.get<Site>(url);
  }
  /**
   * Update
   * @param site Site
   */
  update(site: Site) {
    const url = `${this.url}${site.id}/`;
    return this.http.put<Site>(url, site);
  }
  /**
   * Move
   * @param id IdPage, destination
   */
  move(id: number, destination: any) {
    const params = new HttpParams()
      .set('destination_id', destination);
    return this.http.get(`${this.url_pages}${id}/drag_drop/`, {params});
  }
  /**
   * Delete
   * @param id IdPage
   */
  delete(id: number) {
    const url = `${this.url_pages}${id}`;
    return this.http.delete<void>(url);
  }

}
